// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  scriptId: __t.u64().primaryKey().name("script_id"),
  worldId: __t.u64().name("world_id"),
  partId: __t.u64().name("part_id"),
  contractId: __t.u64().name("contract_id"),
  attachedBy: __t.identity().name("attached_by"),
  attachedAt: __t.timestamp().name("attached_at"),
});
